<template>
    <footer class="d-print-none">
        <div class="row">
            <div class="col-lg-6 d-lg-block d-none">
                <img alt="TTI Logo" src="@/assets/footer.png"/>
            </div>
            <div class="col-lg-6 col-md-12 d-md-block d-none text-right">
                <ul>
                    <li>
                        <address class="mb-0">
                            Network and Information Systems
                            <br/>
                            Texas A&amp;M Transportation Institute
                            <br/>
                            College Station, Texas 77843
                        </address>
                    </li>
                    <li>
                        <span>{{version}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
    import {Configuration} from "@/Configuration";

    export default {
        computed: {
            version() {
                return Configuration.Version;
            }
        }
    };
</script>

<style scoped>
    footer {
        background-color: rgb(166, 166, 166);
        border-top: 3px solid #500000;
        bottom: 0;
        font-size: 9pt;
        margin-top: 2px;
    }

    footer img {
        margin-left: 8px;
        padding-top: 8px;
    }

    footer ul {
        margin-bottom: 4px;
        margin-right: 8px;
        margin-top: 4px;
    }

    footer ul li {
        list-style-type: none;
        text-align: right;
    }
</style>
